
<template>
	<div>
		<a-form-model :model="searchData" style="display:flex;flex-wrap: wrap" layout="inline">
		 <a-form-model-item >
               <a-input style="width:150px"  v-model="searchData.name" allowClear  placeholder="请输入合同名称"/>
           </a-form-model-item> 
	    	<a-form-model-item >
				<a-select v-model="searchData.type" allowClear placeholder="合同类型" style="width:120px">
					<a-select-option key="4" value="4">扫码登记</a-select-option>
					<a-select-option key="7" value="7">材料预支单</a-select-option>
					<a-select-option key="8" value="8">材料领取单</a-select-option>
					<a-select-option key="9" value="9">材料转运单</a-select-option>
				</a-select>
			</a-form-model-item>
           <a-form-model-item >
              <a-input style="width:100px" v-model="searchData.yi" allowClear  placeholder="乙方姓名"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input style="width:130px" v-model="searchData.yiPhone" allowClear  placeholder="乙方电话"/>
           </a-form-model-item> 
	    	<a-form-model-item >
				<a-select v-model="searchData.yiWorkPlace" allowClear placeholder="所属工地" style="width:180px">
					<a-select-option v-for="item in workplaceArray" :key="item.id" :value="item.name" >{{item.name}}</a-select-option>
				</a-select>
           </a-form-model-item> 
		   <a-form-model-item>
			   <a-date-picker style="width:120px" v-model="searchData.tt1" allowClear placeholder="开始时间" ></a-date-picker>
		   </a-form-model-item>
		   <a-form-model-item>
			   <a-date-picker style="width:120px" v-model="searchData.tt2" allowClear placeholder="结束时间" ></a-date-picker>
		   </a-form-model-item>
	    	<a-form-model-item >
				<a-select v-model="searchData.isMoneyGive" allowClear placeholder="是否拨款" style="width:120px">
					<a-select-option key="0" value="0">未拨款</a-select-option>
					<a-select-option key="1" value="1">已拨款</a-select-option>
				</a-select>
			</a-form-model-item>
			<slot name="btns"></slot>
		</a-form-model>
	</div>
</template>

<script>
import {getAll} from "@/api/workplace.js"
import {getSearchParm} from "@/utils/index.js"

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)

let dd1 = localStorage.getItem("date1"),dd2=localStorage.getItem("date2")
if(dd1){dd1 = dd1.substring(0,7)}
if(dd2){dd2 = dd2.substring(0,7)}
export default {
	data(){
		return {
			searchData:getSearchParm({
				name:"",
                yi:"",
                yiPhone:"",
                yiWorkPlace:undefined,
				isMoneyGive:"",
				tt1:dd1,
				tt2:dd2,
				type:"",
				cmpid:user.cmpid
			}),
			workplaceArray:[],
		}
	},
	methods:{
		getformdata(){
			return this.searchData
		},
		getwokes(){
			getAll().then(ret=>{
				let {data} = ret
				this.workplaceArray = data
			})
		},
	},
	mounted(){
		this.getwokes()
	}	
}
</script>

